import { Space, Tooltip } from 'antd'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
// import SelectOptions from 'general/constants/SelectOptions'
import Utils, { findObjectInArray } from 'general/utils/Utils'
import useFilter from 'hooks/useFilter'
// import { useMemo } from 'react'
import { InvoiceTable } from './components/InvoiceTable'
import Modals from './components/Modals'
import { defaultValues, filterOptions, renderInvoiceType } from './constant'
import useAppDnD from 'hooks/useAppDnD'
import useGetSerials from 'hooks/Queries/useGetSerials'
// import SelectOptions from 'general/constants/SelectOptions'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import CustomAntSelect from 'general/components/CustomAntSelect'
import { useEffect, useState } from 'react'
import useSearchDebounce from 'hooks/useSearchDebounce'
import {
  useCopyQueryListInvoice,
  useMutationPullBulkMessage,
  useQueryListInvoice,
} from './components/queries'
import _ from 'lodash'
// import { useMutationGetBulkMessage } from 'features/Invoice/screens/ListInvoice/queries'
import { ActionsTable } from './components/InvoiceTable/ActionsTable'
import dayjs from 'dayjs'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import { useAppSelector } from 'hooks/useRedux'
import { shallowEqual } from 'react-redux'
import { useTransactionSelector } from 'features/Invoice/screens/ListTransactions/slice'
import { useDispatch } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { thunkFindJobposition } from 'features/Jobposition/jobpositionSlice'
import {
  thunkCopys,
  thunkChangeStatusRemoveInvoice,
  thunkUpdateNumberFormatInvoices,
  setModalsState,
} from 'features/Invoice/invoiceSlice'
import ToastHelper from 'general/helpers/ToastHelper'
import axiosClient from 'api/axiosClient'
import reportApi from 'api/reportApi'
import { saveAs } from 'file-saver'
import ModalUpdateNumberFormatAll from 'general/components/Modal/ModalUpdateNumberFormatAll'
import { SEND_TAX_STATUS } from 'general/constants/AppConstants'
import invoiceApi from 'api/invoiceApi'
import ModalUnauthorized from 'general/components/Modal/ModalUnauthorized'
import ModalDataTransmissionLog from 'general/components/ModalDataTransmissionLog'
import TvanHandleApi from 'api/TvanHandleApi'
import ModalUpdateSendTaxStatus from './components/ModalUpdateSendTaxStatus'
export const TvanHandle = () => {
  // base state
  const [tvanState, setTvanState] = useState({})
  const [modalsStateTvan, setModalsStateTvan] = useState({})
  const [disableCopy, setDisableCopy] = useState(false)
  const [disableExport, setDisableExport] = useState(false)
  const [modalsStateDataSetting, setModalsStateDataSetting] = useState({})
  const [activeInvoice, setActiveInvoice] = useState(null)
  const [showEditUpdateSendTaxStatus, setShowEditUpdateSendTaxStatus] =
    useState({
      show: false,
    })
  const [
    disableChangeStatusRemoveInvoice,
    setDisableChangeStatusRemoveInvoice,
  ] = useState(false)
  const [filterParams, setFilterParams] = useFilter(
    'TvanHandle',
    'gFiltersTvanHandle',
  )
  const { mutate: checkMessages, isPending: checkingBulkMessage } =
    useMutationPullBulkMessage()
  const { toggledClearRows, modalStates } = useAppSelector(
    (state) => state.invoice,
    shallowEqual,
  )
  const fetchInvoiceData = async (invoiceId, isTaxAuthorityMessage) => {
    try {
      const res = await invoiceApi.findById(
        invoiceId,
        undefined,
        isTaxAuthorityMessage,
        undefined,
        1,
        1,
      )
      console.log('res', res)
      return res
    } catch (err) {
      ToastHelper.showError('Có lỗi khi tìm dữ liệu')
    }
  }

  const defaultColumns = [
    {
      id: 'sellerTaxCode',
      name: 'Mã số thuế',
      minWidth: '110px',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            style={{
              textAlign: 'center',
            }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.sellerTaxCode}
          </p>
        )
      },
    },
    {
      id: 'serial',
      name: 'Ký hiệu',
      minWidth: '110px',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            style={{
              textAlign: 'center',
            }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.serial}
          </p>
        )
      },
    },
    {
      id: 'no',
      name: 'Số',
      minWidth: '200px',
      center: true,
      omit: false,
      cell: (row) => {
        let dataCopyInvoice = findObjectInArray(
          copyData,
          'invoiceId',
          row.invoiceId,
        )
        return (
          <p
            style={{
              textAlign: 'center',
            }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {dataCopyInvoice && dataCopyInvoice.count > 0 ? (
              <span style={{ color: 'red' }}>
                {`${row?.no ? `${row?.no} x ` : ''} (${dataCopyInvoice.count})
                nhân bản`}
              </span>
            ) : (
              `${row?.no ?? ''}`
            )}
          </p>
        )
      },
    },
    {
      id: 'messageId',
      name: 'Mã thông điệp',
      minWidth: '250px',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            style={{
              textAlign: 'center',
            }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.messageId}
          </p>
        )
      },
    },
    {
      id: 'taxAuthorityCode',
      name: 'Mã CQT',
      center: true,
      omit: false,
      minWidth: '15rem',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.taxAuthorityCode}
          </p>
        )
      },
    },
    {
      id: 'type',
      name: 'Loại hóa đơn',
      center: true,
      omit: false,
      minWidth: '115px',
      cell: (row) => {
        return (
          <div className="w-100 align-items-center justify-content-center">
            {renderInvoiceType(row?.type)}
          </div>
        )
      },
    },
    {
      id: 'issueStatus',
      name: 'Trạng thái phát hành',
      center: true,
      omit: false,
      minWidth: '150px',
      cell: (row) => {
        const { color, text } = InvoiceHelper.renderIssueStatus(row.issueStatus)
        return (
          <p data-tag="allowRowEvents" className={`badge badge-light-${color}`}>
            {text}
          </p>
        )
      },
    },
    {
      id: 'sendTaxStatus',
      name: 'Trạng thái gửi CQT',
      center: true,
      omit: false,
      minWidth: '150px',
      cell: (row) => {
        const { color, text } = InvoiceHelper.renderSendTaxStatus(
          row.sendTaxStatus,
        )
        return row.sendTaxStatus == SEND_TAX_STATUS.INVOICE_INVALID ? (
          <Tooltip
            title="Xem lý do"
            onClick={async () => {
              let res = await fetchInvoiceData(row?.invoiceId, 1)
              if (res?.result === 'success') {
                setActiveInvoice(res?.data)
                dispatch(
                  setModalsState({
                    modalName: 'transmission',
                    status: true,
                  }),
                )
              }
            }}
          >
            <p
              data-tag="allowRowEvents"
              className={`badge badge-light-${color}`}
            >
              {text}
            </p>
          </Tooltip>
        ) : (
          <p data-tag="allowRowEvents" className={`badge badge-light-${color}`}>
            {text}
          </p>
        )
      },
    },
    {
      id: 'date',
      name: 'Ngày tạo',
      center: true,
      omit: false,
      minWidth: '115px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {dayjs(row?.date).format('DD/MM/YYYY')}
          </p>
        )
      },
    },
    {
      id: 'dateSellerSign',
      name: 'Ngày ký',
      center: true,
      omit: false,
      minWidth: '115px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {dayjs(row?.dateSellerSign).format('DD/MM/YYYY')}
          </p>
        )
      },
    },
    {
      id: 'lookupCode',
      name: 'Mã tra cứu',
      center: true,
      omit: false,
      minWidth: '150px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-red-75 font-weight-normal m-0 text-maxline-3 "
          >
            {row?.lookupCode}
          </p>
        )
      },
    },
    {
      id: 'messageTax',
      name: 'Thông điệp hiện tại',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            style={{
              textAlign: 'center',
            }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.messageTax}
          </p>
        )
      },
    },
    {
      name: 'Hành động',
      center: true,
      disabled: true,
      compact: true,
      minWidth: '200px',
      grow: 2,
      style: {
        justifyContent: 'flex-end',
      },
      cell: (row) => (
        <ActionsTable
          row={row}
          tvanState={tvanState}
          setTvanState={({ key, value }) => handleChange({ key, value })}
          modalsState={modalsStateTvan}
          setModalsState={({ key, value }) =>
            handleChangeModalState({ key, value })
          }
          refetchListInvoice={refetchListInvoice}
        />
      ),
    },
  ]
  const dynamicColumns = useAppDnD(defaultColumns)

  const { clearSelectedRows, selectedRows } = useTransactionSelector()

  const handleChange = ({ key, value }) => {
    const cloneTvanState = { ...tvanState }
    cloneTvanState[key] = value
    setTvanState(cloneTvanState)
  }
  const handleChangeModalState = ({ key, value }) => {
    const cloneModasState = { ...modalsStateTvan }
    cloneModasState[key] = value
    setModalsStateTvan(cloneModasState)
  }
  // hiển thị
  // Gán dữ liệu ban đầu
  useEffect(() => {
    const cloneTvanState = { ...tvanState }
    cloneTvanState.keySearch =
      cloneTvanState.keySearch ?? filterOptions[0].value
    setTvanState(cloneTvanState)
  }, [])

  const dispatch = useDispatch()

  // lấy danh sách hóa đơn
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const {
    data: invoiceListData,
    copyData,
    isGettingListData,
    isRefetching,
    refetchListInvoice,
  } = useQueryListInvoice({
    ...filterParams,
    [tvanState.keySearch]: debouncedSearch,
    // [tvanState.keySearch]: tvanState.searchValue,
  })
  // Làm mới dữ liệu hóa đơn
  useEffect(() => {
    refetchListInvoice()
  }, [
    filterParams,
    refetchListInvoice,
    tvanState.keySearch,
    tvanState.searchValue,
    debouncedSearch,
  ])

  // const { data: dataCopys, copyRefetch } = useCopyQueryListInvoice({
  //   invoiceIds: [-1],
  // })

  const downloadInvoiceStatsFile = async (params) => {
    try {
      setDisableExport(true)
      const response = await reportApi.exportTvanReportFile(params)
      // Tạo blob và trigger tải xuống
      saveAs(response, 'thongke.xlsx')
      setDisableExport(false)
    } catch (error) {
      setDisableExport(false)
      console.error('Lỗi tải file thống kê:', error)
      throw error
    }
  }

  const copyRefetch = async () => {
    setDisableCopy(true)
    const invoiceIds = selectedRows.map((item) => item.invoiceId)
    const result = unwrapResult(await dispatch(thunkCopys({ invoiceIds })))
    setDisableCopy(false)
    if (result?.result === 'success') {
      ToastHelper.showSuccess(
        `Nhân bản ${invoiceIds.length} hóa đơn thành công`,
      )
      refetchListInvoice()
    } else {
      ToastHelper.showError(`Nhân bản ${invoiceIds.length} hóa đơn thất bại`)
    }
  }

  const updateDataSendTaxStatus = async (invoiceIds) => {
    // Your logic to move to send invoice goes here
    // For example, you can call an API endpoint to move to send invoice
    // await sendInvoiceToHandler(payload)
    let check = false
    if (!dataConfix?.reason) {
      ToastHelper.showError('Vui nhập lý do thay đổi hóa đơn')
      check = true
    }
    if (check) return
    try {
      const { result, message } =
        await TvanHandleApi.updateSendTaxStatusInvoiceSendQueue({
          invoiceIds,
          reason: dataConfix?.reason,
        })
      if (result === 'success') {
        ToastHelper.showSuccess('Cập nhật hóa đơn thành công')

        refetchList()
        setModalsState({ show: false, data: {} })
      } else {
        ToastHelper.error('Lỗi nội bộ máy chủ')
      }
    } catch (error) {
      console.error('Occured error at update function: ' + error)
    }
  }

  const changeStatusRemoveInvoiceRefetch = async () => {
    setDisableChangeStatusRemoveInvoice(true)
    const invoiceIds = selectedRows.map((item) => item.invoiceId)
    const result = unwrapResult(
      await dispatch(thunkChangeStatusRemoveInvoice({ invoiceIds })),
    )
    setDisableChangeStatusRemoveInvoice(false)
    if (result?.result === 'success') {
      ToastHelper.showSuccess(
        `Cập nhật trạng thái đã xóa cho ${invoiceIds.length} hóa đơn thành công`,
      )
      refetchListInvoice()
    } else {
      ToastHelper.showError(
        `Cập nhật trạng thái đã xóa cho ${invoiceIds.length} hóa đơn thất bại`,
      )
    }
  }

  const submitSaveInvoice = async (invoiceIds, numberFormat) => {
    try {
      const data = unwrapResult(
        await dispatch(
          thunkUpdateNumberFormatInvoices({
            invoiceIds,
            numberFormat,
          }),
        ),
      )
      if (data?.result == 'success') {
        ToastHelper.showSuccess(
          'Cập nhật cấu hình thập phân hóa đơn thành công',
        )
      } else {
        ToastHelper.showError('Cập nhật cấu hình thập phân hóa đơn thất bại')
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const buttonGroups = [
    {
      text: 'Nhân bản',
      icon: 'fa-light fa-check',
      color: '#3CC65E',
      onClick: () => {
        copyRefetch()
      },
      width: 150,
    },
    {
      text: 'Đổi trạng thái đã xóa',
      icon: 'fa-light fa-check',
      color: '#ee2334',
      onClick: () => {
        changeStatusRemoveInvoiceRefetch()
      },
      width: 210,
    },
    {
      text: 'Cậu hình tiền tệ',
      icon: 'fa-light fa-check',
      color: '#2359eeff',
      onClick: () => {
        setModalsStateDataSetting({ show: true })
      },
      width: 200,
    },
    {
      text: 'Cập nhật hóa đơn hợp lệ',
      icon: 'fa-light fa-check',
      color: '#659671ff',
      onClick: () => {
        const invoiceIds = selectedRows.map((item) => item.invoiceId)
        setShowEditUpdateSendTaxStatus({ show: true, data: { invoiceIds } })
      },
      width: 150,
    },
  ]

  // Lọc
  // bảng
  // kéo mã
  // chuyển về gửi lỗi
  // cập nhật thông điệp
  return (
    <ContentContainer wrapperClassName={'list-issued-ticket'}>
      <ContentContainer.Header
        titleContent={'Xử lý truyền nhận Tvan1'}
        toolBar={
          <Space className="d-flex">
            <CustomAntButton
              iconCn={Utils.cn(
                'far fa-rotate',
                checkingBulkMessage && 'fa-spin',
              )}
              text="Kéo mã Tvan"
              antProps={{
                type: 'default',
                title: 'Kéo mã',
                className: 'p-3',
                shape: 'round',
                disabled: checkingBulkMessage,
                onClick: () =>
                  checkMessages(_.pick(filterParams, ['startDate', 'endDate'])),
              }}
              customStyle={{
                minWidth: 'fit-content',
              }}
            />

            <AppDnD
              defaultColumns={defaultColumns}
              localStorageName={PreferenceKeys.TvanHandle}
            />
          </Space>
        }
      />
      <Space className="ml-5">
        <Space>
          <CustomAntInput
            type="search"
            borderRadius="sm"
            width={150}
            inputProps={{
              value: search,
              onChange: (e) => {
                setSearch(e.target.value)
                // set page is 1 when search
                setFilterParams({ page: 1 })
              },
            }}
          />
          <CustomAntSelect
            className="adjustReplaceTicket-select"
            options={filterOptions}
            placeholder="Chọn tiêu chí tìm kiếm"
            value={tvanState.keySearch}
            onChange={(val) => handleChange({ key: 'keySearch', value: val })}
          />
        </Space>
        <FilterPopover
          menuPosition="bottomLeft"
          defaultValues={defaultValues()}
          savedKey={'gFiltersTvanHandle'}
          onApply={setFilterParams}
        />
        <CustomAntButton
          text="Xuất excel"
          iconCn={Utils.cn(
            'fa-solid mr-2 p-0',
            disableExport ? 'fa-spinner-third fa-spin' : 'fa-down-to-line',
            // isPending ? 'fa-spinner-third fa-spin' : 'fa-down-to-line',
          )}
          antProps={{
            disabled: disableExport,
            className: 'btn btn-success',
            onClick: async () => {
              downloadInvoiceStatsFile({
                ...filterParams,
                [tvanState.keySearch]: debouncedSearch,
              })
            },
          }}
        />
      </Space>

      {/* toolBar=
        {
          <FilterPopover
            menuPosition="bottomLeft"
            defaultValues={defaultValues}
            savedKey={'gFiltersInvoiceList'}
            onApply={() => setFilterParams}
          />
        } */}
      {/* {renderInvoiceActionButtons()} */}
      {/* <FilterPopover
        menuPosition="bottomLeft"
        defaultValues={defaultValues}
        savedKey={'gFiltersInvoiceList'}
        onApply={() => setFilterParams}
      /> */}
      <ContentContainer.Body>
        {selectedRows && selectedRows.length > 0 && (
          <div className="row">
            <table style={{ width: 500 }}>
              <tr>
                {buttonGroups.map((bg, index) => (
                  <td style={{ width: bg.width }}>
                    <div>
                      <CustomAntButton
                        key={bg.text}
                        text={bg.text + ' (' + selectedRows.length + ')'}
                        fontSizeText={12}
                        iconCn={bg.icon}
                        color={bg.color}
                        antProps={{
                          danger: bg.danger,
                          disabled:
                            bg.text == 'Nhân bản'
                              ? disableCopy
                              : disableChangeStatusRemoveInvoice,
                          type: bg.type ?? 'primary',
                          className: Utils.cn(
                            bg.className,
                            bg.disabled ? 'disabled' : '',
                          ),
                          onClick: bg.onClick,
                        }}
                      />
                    </div>
                  </td>
                ))}
              </tr>
            </table>
          </div>
        )}

        <br />

        <InvoiceTable
          defaultColumns={dynamicColumns}
          dataSource={invoiceListData}
          isLoading={isGettingListData || isRefetching}
          tvanState={tvanState}
          setTvanState={({ key, value }) => handleChange({ key, value })}
          filterParams={filterParams}
          setFilterParams={setFilterParams}
        />
        <Modals
          tvanState={tvanState}
          setTvanState={({ key, value }) => handleChange({ key, value })}
          modalsState={modalsStateTvan}
          setModalsState={({ key, value }) =>
            handleChangeModalState({ key, value })
          }
          refetchListInvoice={refetchListInvoice}
          row={tvanState.activeRow}
        />
        <ModalUpdateNumberFormatAll
          show={modalsStateDataSetting?.show}
          onHide={() => setModalsStateDataSetting({ show: false })}
          title={`Thông tin cập nhật số thập phân (${selectedRows.map((item) => item.invoiceId).length}) hóa đơn`}
          objectIds={selectedRows.map((item) => item.invoiceId)}
          selectedRows={selectedRows}
        />
        {modalStates.transmission && (
          <ModalDataTransmissionLog
            show={modalStates.transmission}
            onHide={() =>
              dispatch(
                setModalsState({
                  modalName: 'transmission',
                  status: false,
                }),
              )
            }
            invoice={activeInvoice}
          />
        )}

        <ModalUpdateSendTaxStatus
          modalsState={showEditUpdateSendTaxStatus}
          setModalsState={(value) => {
            setShowEditUpdateSendTaxStatus(value)
          }}
          refetchList={() => {
            refetchListInvoice()
          }}
        />
      </ContentContainer.Body>
    </ContentContainer>
  )
}
